export default __webpack_public_path__ + "static/media/s4.e52be40f.jpg";